:host {
    display:block;

	/**
    * @prop --font-family-regular: Font family of regular text
	* @prop --font-family-medium: Font family of medium text
	* @prop --color-text: Color of text. Default value black
    * @prop --color-primary: Primary color. Default adesso-blue
	* @prop --color-focus: Color focus - used for focus state. Default value --color-secondary-mustard
    * @prop --color-input-bg: Background color of input fields. Default value --color-tertiary-grey--lighter
	* @prop --color-result-bg: Background color of input fields. Default value --color-tertiary-grey--lighter
	* @prop --color-result-bg-hover: Background color of input fields. Default value --color-tertiary-grey--lighter
	* @prop --color-result-breadcrumb: Color of breadcrumb text. Default value --color-tertiary-warmgrey
    */
}

* {
	font-family:var(--font-family-regular, --font-klavika-regular);
}

a {
	color: var(--color-text, black);
	display:block;
	text-decoration:none;
	border:solid transparent 1px;
}

li[data-type="result"] a {
	background-color:var(--color-result-bg, rgb(var(--color-tertiary-grey--lighter)));
	padding:1rem;
	opacity:1;
}

li[data-type="result"] a:hover {
	background-color:var(--color-result-bg-hover, rgb(var(--color-tertiary-grey--light)));
}

ul {
	list-style-type:none;
	margin:0;
	padding:0;
	display:flex;
	flex-direction:column;
}

li a, li[data-type="title"] {
	padding-inline-start:1em;
	padding-inline-end:1em;
}

li[data-type="title"] {
	padding-block-start: 1em;
}

li[data-type="autocomplete"] a:hover, li[data-type="autocomplete"] a:focus {
	background-color:var(--color-primary, rgb(var(--color-primary-blue)));
	color:white;
}

li {
	margin-block-end:.5rem;
}

.flex {
	display:flex;
}

.breadcrumb {
	color: var(--color-result-breadcrumb, rgb(var(--color-tertiary-warmgrey)));
	display:none;
}

.breadcrumb ad-icon {
	vertical-align: middle;
	font-size:smaller;
}

@container (min-width:600px) {
	.breadcrumb {
		display:block;
	}
}

#search {
	background-color:var(--color-input-bg, rgb(var(--color-tertiary-grey--lighter)));
	border: solid 1px var(--color-input-bg, rgb(var(--color-tertiary-grey--lighter)));
	font-size:1rem;
	padding:1rem;
	width:100%;
	display:flex;
}

#search::-webkit-search-decoration {
	display:none;
}

#search::-webkit-search-cancel-button {
	-webkit-appearance: none;
	height: 1em;
	width: 1em;
	background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'%3E%3Cpath d='M338.1 413.4c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L203.3 256 349.4 109.9c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L192 244.7 45.9 98.6c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L180.7 256 34.6 402.1c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L192 267.3 338.1 413.4z'/%3E%3C/svg%3E"); no-repeat 50% 50%;
	background-size: contain;
	background-repeat: no-repeat;
	pointer:all;

}

#search::-webkit-calendar-picker-indicator {
	-webkit-appearance: none;
	position:absolute;
	opacity:0;
}

#search::-webkit-search-decoration {
	display:none;
}

*:focus, #search:focus, .inputcontainer button:focus {
	outline:none;
	border: solid 1px var(--color-focus, rgb(var(--color-secondary-mustard)));
}

.inputcontainer {
	width:100%;
	align-self:center;
	position:relative;
	container-type:inline-size;
	z-index:999;
}

.inputcontainer button {
	border:1px solid transparent;
	background-color:var(--color-primary, rgb(var(--color-primary-blue)));
	cursor:pointer;
	color:white;
	width:50px;
	height:auto;
	position:relative;
	font-size:1.5rem;
}

.inputcontainer button i {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}

.inputcontainer:focus-within #searchSuggestions,
#search:focus ~ #searchSuggestions,
#searchSuggestions:focus-within,
#searchSuggestions:focus,
#searchSuggestions:active,
#searchSuggestions.active {
  display: block;
}

#searchSuggestions {
	display:none;
	position:absolute;
	top:100%;
	width:100%;
	max-height:80vh;
	max-height:calc(var(--doc-height)*0.8);
	max-height:80dvh;
	overflow-x:hidden;
	overflow-y:auto;
	background-color:white;
	left:0;
	box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.3);
	transition:all .4s ease;
}

:host(.static-suggestions) #searchSuggestions {
	display:block;
	position:static;
	box-shadow:none;
	max-height:unset;
	overflow:hidden;
}


em, strong {
	font-style:normal;
	font-weight:normal;
	font-family: var(--font-family-medium, --font-klavika-medium);
}

em {
	color: var(--color-primary, rgb(var(--color-primary-blue)));
}

[disabled] {
	filter: grayscale(100%);
	opacity:0.8;
	cursor:not-allowed !important;
}